import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Definition } from '../../definition/definition';
import { DefinitionService } from '../../definition/definition.service';
import { StoreStatusType } from '../../identity/constant/store-status-type.enum';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'mtn-store-status-view',
  templateUrl: './store-status-view.component.html',
  styleUrls: ['./store-status-view.component.scss']
})
export class StoreStatusViewComponent implements OnChanges, OnDestroy {

  @Input()
  type: StoreStatusType;
  @Input()
  definition: Definition<StoreStatusType>;

  private subscription: Subscription;

  constructor(private definitionService: DefinitionService) {
  }

  ngOnChanges(): void {
    this.loadDefinition();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private loadDefinition(): void {
    // Guard: Only load if type is valid and definition needs updating
    if (!this.type) {
      return;
    }

    if (!this.definition || this.definition.systemName !== this.type) {
      // Cancel any pending subscription to prevent duplicate calls
      if (this.subscription) {
        this.subscription.unsubscribe();
      }

      this.subscription = this.definitionService.findOneStoreStatusType(this.type)
        .pipe(take(1))
        .subscribe((definition: Definition<StoreStatusType>) => {
          this.definition = definition;
        });
    }
  }
}
